/**
 * Stable article priorities for the Learn surface.
 *
 * These IDs are locale-independent content IDs. The screen resolves them
 * against the live content registry and fills any remaining slots with the
 * current catalogue, so missing or newly-added content cannot break Learn.
 */
const RECOMMENDED_IDS_BY_GOAL: Record<string, string[]> = {
  "egg-freezing": [
    "moon-article-egg-freezing-timeline",
    "moon-article-cycle-process",
    "moon-article-supplements",
  ],
  "egg-preserve": [
    "moon-article-egg-freezing-timeline",
    "moon-article-cycle-process",
    "moon-article-supplements",
  ],
  "embryo-freezing": [
    "moon-article-embryo-freezing",
    "moon-article-eggs-vs-embryos",
    "moon-article-pgt-testing",
  ],
  "embryo-preserve": [
    "moon-article-embryo-freezing",
    "moon-article-eggs-vs-embryos",
    "moon-article-pgt-testing",
  ],
  "sperm-freezing": [
    "new-article-sperm-freezing-guide",
    "new-article-male-factor",
    "moon-article-cycle-process",
  ],
  "sperm-preserve": [
    "new-article-sperm-freezing-guide",
    "new-article-male-factor",
    "moon-article-cycle-process",
  ],
  pregnancy: ["moon-article-understanding-numbers", "moon-article-pgt-testing"],
  ivf: [
    "moon-article-fresh-vs-frozen-choice",
    "moon-article-insurance-fertility",
  ],
  iui: ["moon-article-cycle-process", "moon-article-understanding-numbers"],
  fet: [
    "moon-article-fresh-vs-frozen-choice",
    "moon-article-insurance-fertility",
  ],
  exploring: [
    "moon-article-cycle-process",
    "moon-article-understanding-numbers",
  ],
};

const PCOS_RECOMMENDED_ID = "moon-article-understanding-numbers";
const FALLBACK_RECOMMENDED_IDS = [
  "moon-article-cycle-process",
  "moon-article-understanding-numbers",
];

export function getRecommendedArticleIds(
  treatmentGoal: string | null,
  conditions: string[] | undefined,
  isLoading: boolean,
): string[] {
  if (isLoading) return [];

  const ids: string[] = [];
  const push = (id: string) => {
    if (!ids.includes(id)) ids.push(id);
  };

  for (const id of RECOMMENDED_IDS_BY_GOAL[treatmentGoal ?? ""] ?? []) {
    push(id);
  }
  if (conditions?.some((condition) => condition.toLowerCase() === "pcos")) {
    push(PCOS_RECOMMENDED_ID);
  }
  if (ids.length === 0) {
    for (const id of FALLBACK_RECOMMENDED_IDS) push(id);
  }

  return ids;
}
